import faqAccordion from './faqAccordion';
import {checkFirstTimeVisit} from './popupModal';
import collapseHeader from './collapseHeader';

document.addEventListener('DOMContentLoaded', () => {
    checkFirstTimeVisit('modal-activate-card');
    collapseHeader();
    document.querySelectorAll('.js-accordion').forEach(faqAccordion);
});
